export default __webpack_public_path__ + "static/media/things.fdfa9474.yaml";